// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1eeCP","row":"Node_row__2ONKj","label":"Node_label__20Wrj","footer":"Node_footer__fylae"};